OT.createNS('OT.Autocomplete');

var search;

OT.Autocomplete.searchPathHandler = function searchPathHandler() {
  return window.location.pathname;
};

OT.Autocomplete.buildOnSubmit = function buildOnSubmit(model) {
  return function onSubmit(submission) {
    if (submission.resultType === 'cuisine') {
      OT.Search.Params.set({ Term: null });
      OTSearchBundle.selectCuisine(submission.query.cuisineIds);
    } else {
      window.location.href = submission.url;
    }
  };
};

OT.Autocomplete.getLocationHierarchy = function(model) {
  var locationHierarchyConfig = {
    0: {
      areaIdToParse: undefined,
      legacy: true
    },
    1: {
      areaIdToParse: 'convert',
      legacy: false
    },
    2: {
      areaIdToParse: 'raw',
      legacy: false
    }
  };

  return locationHierarchyConfig[model.Experiments.sv1207 || 0];
};

// .covers, .datetime, .searchText (ignored)
OT.Autocomplete.updatedSearchParameters = {};

OT.Events.on("dtp:change", function(_, data) {
  OT.Autocomplete.updatedSearchParameters = data;
});

OT.Autocomplete.argsBuilder = function legacyArgs(dtp, model) {
  var metroId = model.Request.MetroId;
  var limits = {
    1: 5,
    2: 4
  };
  var limit = limits[model.Experiments.sv1043];

  var locationHierarchyOption = this.getLocationHierarchy(model);
  var QueryCenter = model.Results.QueryCenter;
  var sv1501 = model.Experiments.sv1207 && model.DomainCulture.Culture.indexOf('en') === 0;
  var sv2227 = model.Experiments.sv2227;

  var currentLocationName = null;

  var selectedRegion = _.find(model.Filters.Regions, function(region) {
    return region.IsSelected;
  });

  if (selectedRegion) {
    currentLocationName = selectedRegion.Name;
  } else if (OTSearchData.Display.Metro) {
    currentLocationName = OTSearchData.Display.Metro.Name;
  }

  var sv1691 = model.Experiments.sv1691;
  var sv1691Opts = {};

  if (sv1691 === 1) {
    sv1691Opts = {
      freetextBottom: true,
      highlightFirst: false
    };
  } else if (sv1691 === 2) {
    sv1691Opts = {
      disableSpinner: false,
      freetextAsync: true,
      freetextBottom: true,
      highlightFirst: false
    };
  } else if (sv1691 === 3) {
    sv1691Opts = {
      disableSpinner: false,
      highlightFirst: false
    };
  }


  var promoPageType = 7;

  var enableFreetext = model.DomainCulture.Domain === 'com' && model.DomainCulture.Language === 'en' && model.Request.PageType != promoPageType;

  return _.extend({
    initialTerm: sv2227 ? model.Request.Term : null,
    addressLocationFallback: !!sv1501,
    addressMapRedirect: false,
    allRestaurantsIcon: model.Experiments.sv1605 - 1,
    areaIdToParse: locationHierarchyOption.areaIdToParse,
    clearInputOnFocus: !sv2227,
    currentLocationName: currentLocationName,
    covers: dtp.covers,
    dateTime: dtp.datetime,
    disableFreetext: !enableFreetext,
    disableAllRestaurants: !model.Experiments.sv1605,
    disableAddresses: false,
    disableLanguageInPath: true,
    disableRecentPlaceholder: true,
    disableCuisines: false,
    domainId: model.DomainInfo.id,
    domainWhitelist: model.DomainWhitelist,
    language: model.DomainCulture.Culture,
    latitude: QueryCenter ? model.Results.QueryCenter.latitude : undefined,
    legacy: locationHierarchyOption.legacy,
    locationFormat: model.Experiments.gpt173 ? 'C' : undefined,
    longitude: QueryCenter ? model.Results.QueryCenter.longitude : undefined,
    metroId: metroId,
    onSelect:  function(data) {
      if (data) {
        OT.Autocomplete.submit({
          covers: OT.Autocomplete.updatedSearchParameters.covers,
          datetime: OT.Autocomplete.updatedSearchParameters.datetime
        });
      }
    },
    onSubmit: OT.Autocomplete.buildOnSubmit(model),
    personalizer: true,
    restaurantLocationName: model.Experiments.gpt173 ? 'N,MN,C' : undefined,
    resultsLimit: limit,
    searchPathHandler: OT.Autocomplete.searchPathHandler,
    secondaryResultsLimit: limit ? 3 : null,
    selector: '#dtp-search-single-box',
    showAddressesToolTip: false
  }, sv1691Opts);
};

OT.Autocomplete.submit = function submit(dtp) {
  var model = OTSearchData;
  var lower = {};

  _.each(model.Request, function (value, key) {
    lower[key.toLowerCase()] = value;
  });

  var searchObj = OT.Search.Helpers.buildSearchParameters.addKnownKeysIfDefined(
    lower,
    OT.Search.Helpers.buildSearchParameters.requestKeys
  );

  search.submit({
    dtp: dtp,
    location: {
      metroId: model.Request.MetroId,
      regionId: model.Request.RegionIds,
      neighborhoodId: model.Request.NeighborhoodIds,
      areaId: model.Request.AreaId,
      latitude: model.Request.Latitude,
      longitude: model.Request.Longitude
    },
    search: searchObj
  });
};

OT.Autocomplete.init = function init() {
  var self = this;

  OT.Events.on('dtp:rendered', function (e, dtp) {
    var res = OT.Autocomplete.argsBuilder(dtp, OTSearchData);
    search = OTAutocomplete.init(res);

    OT.Events.on('dtp:search', function (e, dtp) {
      OT.Autocomplete.submit(dtp);
    });
  });
};
